var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "mainRewardsRef" } },
    [
      _c("div", { staticClass: "top_line" }, [
        _c("span", { staticClass: "mainName" }, [
          _vm._v(
            _vm._s(
              _vm.dataObj.chapter1
                ? _vm.dataObj.chapter1.baseInfo.mainName
                : "--"
            )
          ),
        ]),
      ]),
      _c("el-card", { staticClass: "box-card reward" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [_c("span", [_vm._v("交易主体奖惩信息")])]
        ),
        _c("div", { staticClass: "card-item" }, [
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c("div", [_vm._v("奖励信息：")]),
              _c("rewardsList", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                  dataSource: _vm.allDataListObj.prizeList,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("违法违规信息：")]),
              _c("illlegalList", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                  dataSource: _vm.allDataListObj.punishList1,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("行政处罚信息：")]),
              _c("penaltyList", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("不良行为：")]),
              _c("badBehaviorInformation", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v(" 黑名单记录：")]),
              _c("blackListRecord", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("失信联合惩戒：")]),
              _c("breakPromise", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("信用河南公示信息：")]),
              _c("creditHenan", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                  dataSource: _vm.allDataListObj.creditHnList,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm.tabListIndex != 0 && _vm.tabListIndex != 6
            ? _c(
                "div",
                {
                  staticClass: "remarks",
                  staticStyle: {
                    "margin-left": "24px",
                    "padding-bottom": "12px",
                  },
                },
                [
                  _vm._v(
                    "备注：系统自动归集信息来自国家信用信息公示平台及相关行业主管部门汇集数据库，自动归集信息只可查看，不可编辑！"
                  ),
                ]
              )
            : _vm._e(),
          _vm.tabListIndex != 0 && _vm.tabListIndex == 6
            ? _c(
                "div",
                {
                  staticClass: "remarks",
                  staticStyle: {
                    "margin-left": "24px",
                    "padding-bottom": "12px",
                  },
                },
                [
                  _vm._v(
                    "备注：系统自动归集信息来自信用河南，自动归集信息只可查看，不可编辑！"
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }